import React from 'react';
import { Form, message, Card } from 'antd';
// import { Form, Input, Button, message, Card, Tabs } from 'antd';
import common from "../assets/common.js";
import './login.css';
import logo from '../images/login/logo.png';
import police from '../images/police.png';
// const validateUrl = "/tollhouse/valid-image";
// const TabPane = Tabs.TabPane;

class Login extends React.Component {
  state = {
    time: new Date().getTime(),
    code: '',
    status: '',
    finish: false
  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        var postData = values;
        postData["_url"] = "api/admin/login";
        common.request(postData, this, function(obj, data){
          obj.props.history.push('school');
          window.location.reload();
        },function(obj, data) {
          obj.reValidateUrl();
          message.warning(data.message);
        })
      }
    });
  }
  componentWillMount(){
    this.getCode();
  }
  componentDidMount(){

  }
  /*
    获取code
  */
  getCode = () => {
    var postData = {};
    postData["_url"] = "api/admin/code/login";
    postData["_method"] = "GET";
    common.request(postData, this, function(obj, data){
      obj.setState({
        code: data.result
      });
      obj.getStatus();
    },function(obj, data) {
      message.warning(data.message);
    })
  }
  /*
    获取扫码状态
  */
  getStatus = () => {
    var postData = {};
    postData["_url"] = "api/admin/code/login/status";
    postData["code"] = this.state.code;
    common.request(postData, this, function(obj, data){
      if(!obj.state.finish) {
        setTimeout(function() {
          if(data.result.status === "SUCCESS")  {
            obj.props.history.push('school');
            window.location.reload();
          } else if(data.result.status === "USED" || data.result.status === "TIMEOUT"){
            obj.setState({
              finish: true
            });
          } else if(data.result.status === "WAIT") {
            obj.getStatus();
          }
        }, 1000);
      }
      obj.setState({
        status: data.result.status
      });
    },function(obj, data) {
      message.warning(data.message);
    })
  }

  /**
   * 刷新验证码
   */
  reValidateUrl = () => {
    // 以下URL带上了版本号v，原因如下：
    // URL相同时，火狐浏览器及edge浏览器认为验证码图片没有改变，导致无法刷新验证码
    this.setState({
      time : new Date().getTime(),
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const { time, code, status } = this.state;
    const validImg = "acs/valid-image?v=" + time;
    const formItemLayout = {
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
    };
    const url = window.location.origin + "/acs/api/admin/code/login/img?id=" + code;
    return (
      <div id="loginMainMain">
        <div id="loginMainDiv">
          <div id="loginMain">
            <div id="loginMainL"></div>
            <div id="loginBanner">
              <div style={{height: 60,backgroundColor: "#FFF"}}>
                <div id="loginLogo">
                  <a href="https://www.yunban.com">
                    <img src={ logo } alt="" width="50%"/>
                  </a>
                </div>
              </div>
              <Card id="loginFormCard">
                <div>
                  <div id="loginTitle">
                    支付宝扫码登录
                  </div>
                  <div id="loginContent">
                    {(status === "USED" || status === "TIMEOUT") &&
                      <div class="bg">
                        <div class="status"><div>{status}</div><div>请点击刷新</div></div>
                      </div>
                    }
                    <img style={{width: "90%",position:"relative",margin: "auto",left: "0px",right: "0px"}} src={url}/>
                  </div>
                </div>
              </Card>
            </div>

          </div>
        </div>
        <div id="footer" className="text-center">
          Copyright © 2012 - 2026 Yunban. All Rights Reserved.云瓣科技有限公司版权所有 沪ICP备14019811号-2 <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502013871" target="_blank">沪公网安备 31011502013871号<img class="police" src={ police } alt/></a>
        </div>
      </div>
    );
  }
}

const LoginForm = Form.create()(Login);
export default LoginForm;



// WEBPACK FOOTER //
// ./src/index/codelogin.js